export const PDFBuilderColors = [
  ['#F18430', '#FFFFFF'],
  ['#42A5F5', '#1E88E5'],
  ['#BA68C8', '#7B1FA2'],
  ['#EF5350', '#C62828'],
  ['#FF9800', '#EF6C00'],
  ['#66BB6A', '#2E7D32'],
];
